export class Changeset {
  Id: number = 0;
  TableId: number = 0;
  UserId: number = 0;
  TableChangesetId: number = 0;
  Created: Date = new Date();
  Description: string = '';
}
export class ChangesetView {
  Id: number = 0;
  TableId: number = 0;
  UserId: number = 0;
  TableChangesetId: number = 0;
  Created: string = "";
  Description: string = '';
  UserName: string = "";
}
export class Column {
  Id: number = 0;
  TableId: number = 0;
  Name: string = '';
  Description: string = '';
  TypeId: number = 0;
  EnumType: string = '';
  ContextId: number = 0;
  UnitId: number = 0;
  DecimalDigits: number = 0;
}
export class Deployment {
  Id: number = 0;
  UserId: number = 0;
  Created: Date = new Date();
  Description: string = '';
  ApproverUserId: number = 0;
  IsLive: boolean = false;
  LiveDate: Date = new Date();
}
export class DeploymentChangeset {
  Id: number = 0;
  DeploymentId: number = 0;
  ChangesetId: number = 0;
}
export class Enum {
  Id: number = 0;
  CodeId: number = 0;
  Type: string = '';
  Name: string = '';
  Label: string = '';
  Abbreviation: string = '';
  Description: string = '';
  IsInTools: boolean = false;
  ToolsNamespace: string = '';
}
export class Table {
  Id: number = 0;
  Name: string = '';
  Description: string = '';
}

export interface IData {
  Id: number;
  DataId: number;
  FirstChangesetId: number;
  LastChangesetId: number;
  IsEnabled: boolean;
  SortOrder: number;
}